import { render } from "./ppdbtk.vue?vue&type=template&id=dae85b40"
import script from "./ppdbtk.vue?vue&type=script&lang=js"
export * from "./ppdbtk.vue?vue&type=script&lang=js"

import "./ppdbtk.vue?vue&type=style&index=0&id=dae85b40&lang=css"

import exportComponent from "/Users/biwabits/Documents/ProjectDev/yayasan-ahmadyanibinjai/form-ppdb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__